import { render, staticRenderFns } from "./TransferedFile.vue?vue&type=template&id=74536da8&scoped=true"
import script from "./TransferedFile.vue?vue&type=script&lang=js"
export * from "./TransferedFile.vue?vue&type=script&lang=js"
import style0 from "./TransferedFile.vue?vue&type=style&index=0&id=74536da8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74536da8",
  null
  
)

export default component.exports